<template>
  <base-dialog
    :show-cancel="$t('common.action.cancel')"
    :action-name="$t('common.action.remove')"
    :title="$t('page.dashboard.terminals.removeTerminal')"
    :max-width="$vuetify.display.mdAndUp ? '30%' : '100%'"
    @action="deleteTerminal()"
  >
    <template #content>
      <v-row class="mx-10">
        <v-col>
          <v-card-text class="text-center text-body-1 text-grey-darken-2">
            {{ $t("page.dashboard.terminals.confirmRemoveMessage") }}
          </v-card-text>
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script lang="ts" setup>
import BaseDialog from "@/shared/components/Common/BaseDialog.vue";
import { useReaderStore } from "@/terminals/stores/readers";
import { Emit } from "@/shared/enums/emit.enum";

const props = defineProps({
  terminal: {
    type: String,
    default: "",
  },
});

const emit = defineEmits([Emit.DELETED]);

const deleteTerminal = async () => {
  await useReaderStore().removeFavoriteReader({
    terminalId: props.terminal,
  });
  await useReaderStore().fetchFavReader();
  emit(Emit.DELETED);
};
</script>
